"use client";

import { Github, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const shopLinks = [{
  label: "Consulting",
  to: "/OurExpertisePage"
}, {
  label: "Project Management",
  to: "/OurExpertisePage"
}, {
  label: "Strategic Support",
  to: "/OurExpertisePage"
}, {
  label: "All Services",
  to: "/OurExpertisePage"
}];
const companyLinks = [{
  label: "About",
  to: "/TheITLSApproachPage"
}, {
  label: "Philosophy",
  to: "/TheITLSApproachPage"
}, {
  label: "Contact",
  to: "/ConnectPage"
}, {
  label: "Partnerships",
  to: "/ConnectPage"
}];
const supportLinks = [{
  label: "Client Portal",
  to: "/ConnectPage"
}, {
  label: "Resources",
  to: "/InsightsPage"
}, {
  label: "Documentation",
  to: "/InsightsPage"
}, {
  label: "Help Center",
  to: "/ConnectPage"
}];
const socials = [{
  label: "Twitter",
  icon: Twitter,
  to: "#"
}, {
  label: "LinkedIn",
  icon: Linkedin,
  to: "#"
}, {
  label: "Instagram",
  icon: Instagram,
  to: "#"
}, {
  label: "GitHub",
  icon: Github,
  to: "#"
}];
const legalLinks = [{
  label: "Privacy",
  to: "#"
}, {
  label: "Terms",
  to: "#"
}, {
  label: "Accessibility",
  to: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        <div className="h-4 w-24 bg-muted/40 animate-pulse" />
        <div className="h-4 w-20 bg-muted/40 animate-pulse" />
        <div className="h-4 w-28 bg-muted/40 animate-pulse" />
        <div className="h-4 w-16 bg-muted/40 animate-pulse" />
      </div>;
  }
  const items = menuItems && menuItems.length > 0 ? menuItems : companyLinks.map((l, i) => ({
    id: String(i),
    label: l.label,
    href: l.to
  }));
  return <ul className="space-y-3">
      {items.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="inline-block font-default font-medium text-[0.9375rem] text-foreground/85 hover:text-primary transition-colors duration-200 border-b border-transparent hover:border-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="14269" id="site-footer" className="dark bg-background text-foreground py-32 md:py-48 px-5 sm:px-8 md:px-16">
      <div className="mx-auto max-w-[1320px]">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10">
          {}
          <div className="lg:col-span-5 flex flex-col gap-8">
            <Link to="/" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto" />
            </Link>

            <p className="font-default text-[1.0625rem] md:text-[1.125rem] leading-[1.55] text-foreground/70 max-w-md">
              Professional solutions for discerning clients. Excellence in every detail.
            </p>

            <div className="flex items-center gap-3">
              {socials.map((s, i) => {
              const Icon = s.icon;
              return <Link key={s.label} data-index={i} to={s.to} aria-label={s.label} className="group flex items-center justify-center h-12 w-12 border-[1px] border-foreground hover:border-primary transition-colors duration-200">
                    <Icon className="h-5 w-5 text-foreground group-hover:text-primary transition-colors duration-200" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-10 md:gap-8">
            {}
            <div className="flex flex-col">
              <div className="font-mono text-[0.75rem] tracking-[0.18em] uppercase text-foreground/60 mb-3">
                Services
              </div>
              <div className="h-[1px] w-full bg-foreground mb-5" />
              <ul className="space-y-3">
                {shopLinks.map((item, i) => <li data-index={i} key={item.label}>
                    <Link to={item.to} className="inline-block font-default font-medium text-[0.9375rem] text-foreground/85 hover:text-primary transition-colors duration-200 border-b border-transparent hover:border-primary">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div className="flex flex-col">
              <div className="font-mono text-[0.75rem] tracking-[0.18em] uppercase text-foreground/60 mb-3">
                Company
              </div>
              <div className="h-[1px] w-full bg-foreground mb-5" />
              <MenuProvider menu_id="79">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            {}
            <div className="flex flex-col col-span-2 md:col-span-1">
              <div className="font-mono text-[0.75rem] tracking-[0.18em] uppercase text-foreground/60 mb-3">
                Support
              </div>
              <div className="h-[1px] w-full bg-foreground mb-5" />
              <ul className="space-y-3">
                {supportLinks.map((item, i) => <li data-index={i} key={item.label}>
                    <Link to={item.to} className="inline-block font-default font-medium text-[0.9375rem] text-foreground/85 hover:text-primary transition-colors duration-200 border-b border-transparent hover:border-primary">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28">
          <div className="h-[1px] w-full bg-foreground/30 mb-8" />
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="font-mono text-[0.8125rem] tracking-[0.02em] text-foreground/60">
              {"\u00A9 2025 ITLS Professional Services"}
            </p>
            <div className="flex items-center gap-6">
              {legalLinks.map((item, i) => <Link key={item.label} data-index={i} to={item.to} className="font-default font-medium text-[0.8125rem] text-foreground/70 hover:text-primary transition-colors duration-200 border-b border-transparent hover:border-primary">
                  {item.label}
                </Link>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}